<template>
  <sea-page-content
    :fetchList="fetchList"
    :resetList="resetList"
    searchPanel
    searchType="data"
  >
    <v-row no-gutters>
      <v-col col="12" class="text-right pr-2">
        Se non trovi li documento clicca
        <router-link to="/myrequests">qui</router-link>
      </v-col>
    </v-row>
    <template v-slot:table="{ attrs }">
      <v-data-table
        v-bind="attrs"
        :headers="headers"
        :items="items"
        disable-sort
        dense
        height="calc(100vh - 325px)"
      >
        <template v-slot:item.dataConsegna="{ item }">
          {{ item.dataConsegna | dateFormat }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            elevation="2"
            rounded
            x-small
            @click="download(item)"
            color="primary"
          >
            Apri
            <v-icon right dark>mdi-cloud-download </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.statoLettura="{ item }">
          <stato-lettura :stato="item.statoLettura"></stato-lettura>
        </template>
      </v-data-table>
    </template>
  </sea-page-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StatoLettura from "@/components/StatoLettura.vue";

const headers = [
  { text: "Data consegna", value: "dataConsegna", class: "head" },
  { text: "Descrizione", value: "descrizione", class: "head" },
  { text: "Letto", value: "statoLettura", class: "head" },
  { text: "", value: "actions", class: "head", align: "end" },
];

export default {
  name: "documenti-ricevuti",
  components: { StatoLettura },
  data() {
    return {
      headers,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "document/fetchDocuments",
      resetList: "document/resetData",
      download: "document/downloadDocument",
    }),
  },
  computed: {
    ...mapGetters({
      items: "document/data",
    }),
  },
};
</script>

<style>
/** */
</style>
